module.exports = __webpack_public_path__ + "img/net.0f09edfc.png";